import React, {useState } from "react";
import useButtonLoader from "common/UseButtonLoader";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";
import { regex } from "utils/formValidator";
import {Input } from "common/InputForm";
import {  editHastagApi } from "services/hashtag";
import { CustomModal } from "components/modals/ModalBox";
const EditHashtagManagement = ({
  setEditHastag,
  editHastag,
  inputData,
  setInputData,
  hastagListHandler,
}) => {
  const { imageFileRegex } = regex;
  const [buttonLoader, setButtonLoader] = useButtonLoader("Update Hastag");
  const [loader, onShow, onHide] = useFullPageLoader()
  const [errors, setErrors] = useState({});
  const validation = () => {
    let status = true;
    const error = {};
    if (!inputData.title) {
      error["title"] = "Please enter title";
      status = false;
    }
  
    setErrors(error);
    return status;
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };
  // update banner
  const editHastagHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoader(true);
      try {
        const formData = new FormData();
        formData.append("title", inputData?.title || "");
        formData.append("id", inputData._id || "");
        if (inputData.iconPreview)
          formData.append("icon", inputData.iconUrl);
        const res = await editHastagApi(formData);
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "editHastagHandler");
          setEditHastag(false);
          hastagListHandler();
          // navigate(-1);
        } else {
          toastMessage(res?.data?.message, "error", "editHastagHandler");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <>
      {loader}
      <CustomModal
        show={editHastag}
        handleClose={() => {
          setEditHastag(false);
          setInputData({});
        }}
      >
        <h3>Edit Hashtag</h3>
        <div className="form_field_wrap">
       
          <div className="form_field">
          <Input
              type="text"
              label="Title"
              placeholder="Enter name"
              value={inputData.title}
              onChange={onChangeHandler}
              name="title"
              id="title"
              error={errors.title}
            />
          </div>
        </div>
   
        <div className="button_wrap">
          <button
            type="button"
            className="button light"
            onClick={() => {
              setEditHastag(false);
              setInputData({});
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            ref={buttonLoader}
            onClick={editHastagHandler}
            className="button"
          >
            Update
          </button>
        </div>
      </CustomModal>
    </>
  );
};
export default EditHashtagManagement;
